import React, { useEffect, useState } from "react";

import Form from "components/Form";
import {
  ROLES_URL,
  URLS,
  BO_USER_URL,
  ID_TYPES_URL,
  REGION_FETCH_URL,
  ESTATE_FETCH_URL,
  DIVISION_FETCH_URL,
  BLOCK_FETCH_URL,
  ZONE_FETCH_URL,
  LIST_UNSUPERVISED_WORKER_GROUP_URL,
} from "configs/constants";
import { fetchDataFromApi } from "utils";
import * as Yup from "yup";
import ReactSelect from "../../components/FormikControl/ReactSelect";
import { useHistory, useParams } from "react-router-dom";
import eightAxios from "../../configs/axiosConfig";
import { useNotifyContext } from "../../components/Notify";
import { PHONE_NUMBER_KEYS } from "configs/constants";
import { SOURCE_FETCH_URL } from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";
import AllowableEstateDetails from "views/User/AllowableEstateDetails";


export let checkBOUserStatus = false

const initialValues = {
  id_type: "",
  id_number: "",
  name: "",
  username: "",
  role: [],
  status: [],
  mobile_number: "",
  employee_id: "",
  zone: "",
  source: "",
  region: "",
  estate: "",
  block: "",
  nationality: "",
  email: "",
  division: "",
  office_number: "",
  department: "",
  designation: "",
  api: "",
  is_hq: false,
  allowables: {
    All_Estates: false,
    Zones: [],
    Regions: [],
    Estates: [],
  },


  worker_groups: [],
  all_estates: false,
  zones: [],
  estates: [],
  regions: [],
};

const validationSchema = Yup.object({
  name: Yup.string()
    .required("Worker name is required")
    .typeError("Invalid employee name"),
  source: Yup.string()
    .required("Source is required")
    .typeError("Invalid source name")
    .nullable(),

  company: Yup.string()
    .required("Company is required")
    .typeError("Invalid company name")
    .nullable(),
  mobile_number: Yup.string()
    .required("Mobile Number is required")
    .matches(/^[0-9]+$/, "Mobile Number must contain only digits")
    .matches(/^\S*$/, "Spaces at the beginning or end are not allowed")
    .min(8, "Invalid length Min 10, Max 12")
    .max(12, "Mobile Number must not exceed 12 digits")
    .typeError("Invalid mobile number"),
  office_number: Yup.string()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .matches(/^[0-9]+$/, "Mobile Number must contain only digits")
    .matches(/^\S*$/, "Spaces at the beginning or end are not allowed")
    .min(8, "Invalid length Min 10, Max 12")
    .max(12, "Office Number must not exceed 12 digits")
  ,
  id_type: Yup.string()
    .required("ID type is required")
    .typeError("Invalid id type")
    .nullable(),
  id_number: Yup.string()
    .required("ID Number is required")
    .typeError("Invalid ID Number"),
  designation: Yup.string()
    .required("Designation is required")
    .typeError("Invalid designation"),
  role: Yup.array()
    .min(1, "No role selected")
    .required("User role/s is required")
    .typeError("Invalid role/s"),
  all_estates: Yup.boolean().required("All estates is required"),
  email: Yup.string().email("Invalid email address"),
  // zones: Yup.array().nullable().when("all_estates", {
  //   is: (all_estates) => !all_estates,
  //   then: Yup.array().min(1, "zones is a required field").required(),
  //   otherwise: Yup.array().notRequired(),
  // }),
  // regions: Yup.array().when("all_estates", {
  //   is: (all_estates) => !all_estates,
  //   then: Yup.array().nullable().min(1, "regions is a required field").required(),
  //   otherwise: Yup.array().nullable().notRequired(),
  // }),
  // estates: Yup.array().when("all_estates", {
  //   is: (all_estates) => !all_estates,
  //   then: Yup.array().nullable().min(1, "estates is a required field").required(),
  //   otherwise: Yup.array().nullable().notRequired(),
  // }),
});

const UserForm = () => {
  const params = useParams();
  const history = useHistory();
  const setNotify = useNotifyContext();

  const [roles, setRoles] = useState([]);
  const [disableWorkerGroups, setDisableWorkerGroups] = useState(false);
  const [clearWorkerGroups, setClearWorkerGroups] = useState(true);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableAllowableZones, setDisableAllowableZones] = useState(false);
  const [disableAllowableRegions, setDisableAllowableRegions] = useState(false);
  const [hasNoEstates, setHasNoEstates] = useState(true);
  const [clearAllowables, setClearAllowables] = useState(true);
  const [regionClearValue, setRegionClearValue] = useState(true);
  const [selectedErmlType, setSelectedErmlType] = useState(false);
  const [showAllowables, setShowAllowables] = useState(false);
  const [selectedRegions, setSelectedRegions] = useState('');
  const [selectedAllowableType, setSelectedAllowableType] = useState(true)
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [workerGroupCheck, setWorkerGroupCheck] = useState(false);
  const [hasNotSupervisorValue, setHasNotSupervisorValue] = useState(false);
  const [key, setKey] = useState(1);
  const [disableswitch, setDisableswitch] = useState(false);
  const [disableCompany, setDisableCompany] = useState(true);
  const [allowables, setAllowables] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [disableZone, setDisableZone] = useState(true);




  const handleWorkerGroupCheck = (
    e,
    disableWorkerGroups,
    setWorkerGroupCheck) => {
    !e?.length && !disableWorkerGroups
      ? setWorkerGroupCheck(true)
      : setWorkerGroupCheck(false);

  };
  useEffect(() => {
    eightAxios
      .get(`bo-user/${params.id}/`)
      .then((response) => {
        const AllowablesData = response.data.allowables_new_json;
        const modifiedAllowables = AllowablesData.map((allowable) => ({
          ...allowable,
          confirmed: true,
        }));
        setAllowables(modifiedAllowables);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const getRoleValues = (e, setDisableWorkerGroups, setHasNotSupervisorValue) => {
    e
    if (!e) {
      setHasNotSupervisorValue(true);
      setDisableWorkerGroups(true);
    }
    let hasSuperVisor = e && e.filter(element => element.label.toLowerCase() === "supervisor");
    if (hasSuperVisor && hasSuperVisor.length <= 0) {
      setHasNotSupervisorValue(true);
      setDisableWorkerGroups(true);
      setWorkerGroupCheck(false);

    }
    else {
      setHasNotSupervisorValue(false);
      setDisableWorkerGroups(false);
      setWorkerGroupCheck(true);

    }



  };
  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };
  const getEstateValues = (e, setClearWorkerGroups) => {

    if (!e || e.length === 0) {
      setClearWorkerGroups(true);
      setDisableDivision(true);

    }
    else {
      setClearWorkerGroups(false);
      setDisableDivision(false);


    }

  };

  const getRegionsValues = (e) => {

    if (e && e.length > 0) {
      setDisableAllowableZones(true);
    } else {
      setDisableAllowableZones(false);
    }

    setSelectedRegions(e);
  };





  const getZoneValues = (e, setDisableRegion) => {
  //  if (!e || e.length === 0) {
    if (!e || e.length === 0 || e.label == "N/A") {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }

  };

  const getSourceValue = (e, setDisableCompany) => {
    if (!e || e.length === 0) {
      setDisableCompany(true);
    }
    else {
      setDisableCompany(false);
    }

  };
  const getRegionValues = (e, setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }

  };


  const getErmlType = (e) => {
    setDisableswitch(true);
    setSelectedErmlType(e?.value);

  };


  const getDivisonValues = (e, setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }

  };

  

  const handleSubmit = async (values, { setSubmitting }, checker) => {
    let submitVal = values;
    submitVal["from_frontend"] = true;
    let apiKeys = Object.keys(submitVal);
    let data = new FormData();

    apiKeys.forEach((key) => {
      if (Array.isArray(values[key])) {
        values[key].forEach((value) => {
          data.append(key, value);
        });
      } else {
        if (values[key] !== null) data.append(key, values[key]);
      }
    });
    const submitAllowables = allowables.filter(
      (allowables) => allowables.confirmed === true
    );
    
    if (submitAllowables.length === 0 && !values.all_estates) {
      setNotify({
        isOpen: true,
        message: "Please add at least one Allowables.",
        type: "error",
      });
      setSubmitting(false);
      return;
    }

    apiKeys.forEach((key) => {
      if (PHONE_NUMBER_KEYS.includes(key)) {
        if (typeof submitVal[key] === "string" && submitVal[key].trim() !== "") {
          if (submitVal[key].substring(0, 2) !== "60") {
            submitVal[key] = "60" + submitVal[key];
          }
        }
        else if (submitVal[key] === "") {
          submitVal[key] = null;
        }
      }
    });

    
    let notConfirmedAllowablesDetected = false;
    allowables.forEach((allowable) => {
      if (!allowable.confirmed) {
        notConfirmedAllowablesDetected = true;
      }
    });

    if (notConfirmedAllowablesDetected) {
      setNotify({
        isOpen: true,
        message:
          "Please confirm the unconfirmed record changes or remove the record.",
        type: "error",
      });
      setSubmitting(false);
      return;
    }

    if (workerGroupCheck) {
      setNotify({
        isOpen: true,
        message:
          "Supervisor must be assigned zone, region, estate and worker group",
        type: "error",
      });
      setSubmitting(false);
      return;

    }

    if (
      checker ||
      (!checker &&
        values?.worker_groups?.length &&
        values?.zone &&
        values?.region &&
        values?.estate)
    ) {
      for (let i = 0, valuePair; (valuePair = allowables[i]); i++)
      for (let j in valuePair) data.append(j, valuePair[j]);

      var mappedallowables = allowables.map(x => {return {zones : x.zones.value, regions : x.regions.value, estates: x.estates.value}} );
      values.allowables_new_json = mappedallowables;
      values.allowables= mappedallowables;


    submitVal = data;

      eightAxios
        .patch(`${BO_USER_URL}${params.id}/`, values)
        .then(async (response) => {
          setSubmitting(false);
          setNotify({
            isOpen: true,
            message: "user has been updated successfully",
            type: "success",
          });
          setTimeout(function () {
            history.push(URLS.BO_LIST);
          }, 2000);
         
        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: error.response.data.message,
            type: "error",
          });
          setSubmitting(false);
        });
    } else {
      setNotify({
        isOpen: true,
        message:
          "Supervisor must be assigned zone, region, estate and worker group",
        type: "error",
      });
      setSubmitting(false);
    }
  };

  const getAllEstates = (e, setHasNoEstates, setClearAllowables) => {
    if (e?.value === true) {
      setSelectedAllowableType(true);  
      
      setHasNoEstates(true);
      setClearAllowables(false);
    } else {
      setSelectedAllowableType(false);
      
      setHasNoEstates(false);
      setClearAllowables(true);
    }

    setSelectedAllowableType(e?.value);
};
useEffect(() => {
  if (selectedAllowableType) {
    setAllowables([]);
    setIsButtonDisabled(false);

  }
}, [selectedAllowableType]);

  useEffect(() => {

    if (selectedAllowableType == false) {

      setShowAllowables(true);
    }
    else if (selectedAllowableType == null) {
      setShowAllowables(true);
    }

    else {
      setShowAllowables(false);
    }


  }, [selectedAllowableType]);

  const getEstatesValues = (e) => {

    if (e && e.length > 0) {
      setDisableAllowableRegions(true);
    } else {
      setDisableAllowableRegions(false);
    }

  };

  useEffect(() => {
    fetchDataFromApi(ROLES_URL, setRoles, true);
  }, []);

  useEffect(() => {
    const workerRole = roles.find((role) => role.name === "Worker");
    if (roles.includes(workerRole)) {
      setRoles(roles.filter((item) => item.name !== "Worker"));
    }
  }, [roles]);

  let formFields = [
    { type: "title", title: "Personal Details" },
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "input",
      name: "name",
      key: "name",
      label: "Name",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      type: "reactselect",
      name: "id_type",
      label: "ID Type",
      required: true,
      proxyUrl: ID_TYPES_URL,
      paginated: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "input",
      name: "id_number",
      label: "ID Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      type: "input",
      name: "designation",
      label: "Designation",
      required: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },

    },
    {
      type: "input",
      name: "department",
      label: "Department",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },

    },
    {
      type: "input",
      name: "email",
      label: "Email",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "phone",
      name: "office_number",
      label: "Office Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "phone",
      name: "mobile_number",
      label: "Mobile Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },

    {
      name: "is_hq",
      key: "is_hq",
      type: "switch",
      label: "HQ?",
      gridSize: { xs: 12, sm: 6, md: 2, lg: 2 },

      color: "primary",
      //  labelLeft: "No",
      // labelRight: "Yes",




    },
    {
      name: "api",
      key: "api",
      type: "switch",
      label: "API",
      disabled: disableswitch,
      gridSize: { xs: 12, sm: 6, md: 1, lg: 1 },

      color: "primary",
      //   labelLeft: "No",
      // labelRight: "Yes",
      getValue: getErmlType,




    },
    {
      type: "reactselect",
      name: "source",
      label: "Source",
      proxyUrl: SOURCE_FETCH_URL,
      required: true,
      getValue: (e) => getSourceValue(e, setDisableCompany),
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },

      paginated: true,
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      required: true,
      paginated: true,
      disabled: disableCompany,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      optionsDependsOn: "source",
      getValue: (e) => getCompanyValues(e, setDisableZone),


    },


    //FIXME: 10036 - Hide allowables for now
    // {
    //   name: "is_hq",
    //   label: "HQ?",
    //   type: "switch",
    //   labelLeft: "No",
    //   labelRight: "Yes",
    // },

    { type: "title", title: "Employment Details" },

    {
      type: "component",
      name: "role",
      label: "Role",
      renderKey: "role",
      isMultiSelect: true,
      getValue: (e) => getRoleValues(e, setDisableWorkerGroups, setHasNotSupervisorValue, setWorkerGroupCheck),
      required: true,
      proxyUrl: ROLES_URL,
      isPaginationEnabled: false,
      isPageEnabled: 1,
      isPageSizeEnabled: 100,
      discardOptionsByName: ["Worker"],
      component: ReactSelect,
      gridSize: { xs: 12, sm: 6 },


    },
    {
      type: "reactselect",
      name: "status",
      label: "Status",
      outerOptions: [
        { id: "Active", name: "Active" },
        { id: "Inactive", name: "Inactive" },
      ],
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      optionsDependsOn: "company",
      disabled: disableZone,
      supervisorInfoIcon: true,
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      disabled: disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
      supervisorInfoIcon: true,

    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
      disabled: disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),
      supervisorInfoIcon: true,
      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled: disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled: disableBlock,

      optionsDependsOn: "division",
    },

    {
      type: "reactselect",
      name: "worker_groups",
      label: "Worker Group",
      proxyUrl: LIST_UNSUPERVISED_WORKER_GROUP_URL(params.id),
      required: workerGroupCheck,
      getValue: (e) =>
        handleWorkerGroupCheck(e, disableWorkerGroups, setWorkerGroupCheck),

      disabled: disableWorkerGroups,
      clear: clearWorkerGroups,
      filterOnType: true,
      hasNotSupervisor: hasNotSupervisorValue,
      optionsDependsOn: "estate",
      paginated: false,
      isMultiSelect: true,
      gridSize: { xs: 12, sm: 6 },
    },

    //FIXME: 10036 - Hide allowables for now
    { type: "title", title: "Allowable Estate Details" },
    {
      name: "all_estates",
      label: "All Estates?",
      type: "switch",
      labelLeft: "No",
      labelRight: "Yes",
      gridSize: { xs: 12 },
      getValue: (e) => getAllEstates(e, setHasNoEstates, setClearAllowables),
    },
    {
      type: "component",
      component: AllowableEstateDetails,
      allowables: allowables,
      setAllowables: setAllowables,
      isButtonDisabled: isButtonDisabled,
      setIsButtonDisabled: setIsButtonDisabled,
      gridSize: { xs: 12 },
      showField: showAllowables,

    },
  ];

  const formButtons = ["submit", "cancel"];

  return (
    <Form
      key={key}

      validationSchema={validationSchema}
      initialValues={initialValues}
      submitUrl={BO_USER_URL}
      listRoute={URLS.BO_LIST}
      formFields={formFields}
      outerSubmitHandler={(values, { setSubmitting }) =>
        handleSubmit(values, { setSubmitting }, disableWorkerGroups)
      }
      formButtons={formButtons}
      formTitle="Back-Office User"
    />
  );


};

export default UserForm;
